import styled from '@emotion/styled';

export const BottomButtonWrapper = styled.div`
  display: flex;
  width: 100%;
  margin-top: 6px;
  gap: 8px;
`;
